import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    width: 100%;\n\n    ", "\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n                ", ";\n                ", " {\n                    ", "\n                }\n            "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        width: ", "%;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            width: calc(", "% - ", ");\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { getPropsBlocker, makePropList } from '../../../utils';
import { GRID_RESOLUTION } from '../constants';
import { setHorizontalMargin, setVerticalMargin } from '../style';
import { paddingAttributes } from '../../../system/attributes';
var propertyList = makePropList(['gutterSpacing', 'gutterSpacingVertical', 'gutterSpacingHorizontal', 'xs', 'sm', 'md', 'lg', 'xl']);

var setMediaStyle = function setMediaStyle(size, spacing, gutterSpacingX) {
  var width = 100 / GRID_RESOLUTION * size;

  if (gutterSpacingX && gutterSpacingX > 0) {
    return css(_templateObject(), width, spacing(gutterSpacingX));
  }

  return css(_templateObject2(), width);
};

var gridItemRootStyle = function gridItemRootStyle(_ref) {
  var gutterSpacing = _ref.gutterSpacing,
      gutterSpacingVertical = _ref.gutterSpacingVertical,
      gutterSpacingHorizontal = _ref.gutterSpacingHorizontal,
      _ref$theme = _ref.theme,
      breakpoints = _ref$theme.breakpoints,
      GridItem = _ref$theme.componentOverrides.GridItem,
      spacing = _ref$theme.spacing,
      restProps = _objectWithoutProperties(_ref, ["gutterSpacing", "gutterSpacingVertical", "gutterSpacingHorizontal", "theme"]);

  var result = GridItem.Root.base;
  var gutterSpacingX = gutterSpacingHorizontal || gutterSpacing;
  var gutterSpacingY = gutterSpacingVertical || gutterSpacing;

  if (gutterSpacingX && gutterSpacingX > 0) {
    result = css(_templateObject3(), result, setHorizontalMargin(gutterSpacingX, spacing));
  }

  if (gutterSpacingY && gutterSpacingY > 0) {
    result = css(_templateObject4(), result, setVerticalMargin(gutterSpacingY, spacing));
  }

  breakpoints.keys.forEach(function (key) {
    if (restProps[key]) {
      result = css(_templateObject5(), result, breakpoints.up(key), setMediaStyle(restProps[key], spacing, gutterSpacingX));
    }
  });
  return result;
};

export var GridItemRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6(), gridItemRootStyle, paddingAttributes);